import React from "react"
import { useQuery } from "@tanstack/react-query"
import { websiteOrderService } from "@/api/websiteOrderService"
import { Link } from "react-router-dom"
import { formatToDevanagariStyle } from "@/utilities/helper"

export const Orders: React.FC = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["orders", "website"],
    queryFn: ({ signal }) => websiteOrderService.getOrders(signal),
  })

  const orders = (data as any)?.data?.data || []

  console.log("orders", orders)

  if (isLoading) {
    return (
      <div className="bg-gray-50 min-h-screen py-10 flex items-center justify-center">
        <div className="text-gray-500">Loading orders...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="bg-gray-50 min-h-screen py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-sm p-12 text-center">
            <p className="text-red-500">Failed to load orders</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-gray-50 min-h-screen py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Order History</h1>

        {orders.length === 0 ? (
          <div className="bg-white rounded-lg shadow-sm p-12 text-center">
            <p className="text-gray-500 text-lg">No orders found</p>
            <Link
              to="/website"
              className="mt-4 inline-block bg-indigo-600 text-white px-6 py-2 rounded-md hover:bg-indigo-700"
            >
              Start Shopping
            </Link>
          </div>
        ) : (
          <div className="space-y-4">
            {orders.map((order: any) => {
              const orderTotal = order.total_amount || 0
              const orderDate = new Date(
                order.order_date || order.created_at
              ).toLocaleDateString()

              return (
                <div
                  key={order.id}
                  className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow"
                >
                  <div className="flex justify-between items-start">
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">
                        Order #{order.code || order.id}
                      </h3>
                      <p className="text-sm text-gray-500 mt-1">
                        Placed on {orderDate}
                      </p>
                      <p className="text-sm text-gray-500">
                        Status:{" "}
                        <span className="font-medium">
                          {order.status_label || "Pending"}
                        </span>
                      </p>
                    </div>
                    <div className="text-right">
                      <p className="text-lg font-semibold text-gray-900">
                        Rs. {formatToDevanagariStyle(orderTotal)}
                      </p>
                      {/* TODO: make the page to show the order details  */}
                      {/* <Link
                        to={`/website/orders/${order.id}`}
                        className="text-sm text-indigo-600 hover:text-indigo-700 mt-2 inline-block"
                      >
                        View Details
                      </Link> */}
                    </div>
                  </div>

                  {order.order_items && order.order_items.length > 0 && (
                    <div className="mt-4 pt-4 border-t border-gray-200">
                      <div className="flex space-x-4 overflow-x-auto">
                        {order.order_items.slice(0, 3).map((item: any) => (
                          <div key={item.id} className="flex-shrink-0">
                            <div className="w-16 h-16 bg-gray-100 rounded-md flex items-center justify-center">
                              {item?.image ? (
                                <Link
                                  to={`/website/product/${item.id}`}
                                  className="w-full h-full"
                                >
                                  <img
                                    src={item.image.url}
                                    alt={item.name}
                                    className="w-full h-full object-cover rounded-md"
                                  />
                                </Link>
                              ) : (
                                <span className="text-gray-400 text-xs">
                                  No Image
                                </span>
                              )}
                            </div>
                            <p className="text-xs text-gray-600 mt-1 text-center">
                              Qty: {item.quantity}
                            </p>
                          </div>
                        ))}
                        {order.order_items.length > 3 && (
                          <div className="flex-shrink-0 flex items-center">
                            <span className="text-sm text-gray-500">
                              +{order.order_items.length - 3} more
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}
